export enum SmartDealsStatusFilter {
  All = "All",
  Draft = "Draft",
  Blockchain = "Blockchain",
  PromptPayUnderReview = 'PromptPayUnderReview'
}
